/**
 * Clears credentials an older sign-in left in localStorage.
 *
 * COMFORTHUB_SESSION used to hold a live API token and the account's whole
 * permission list; the @@auth0spajs@@ / auth0. entries are from before the switch
 * to Clerk. Nothing in the app reads either any more, but the copies are still on
 * people's machines, where any script on the origin can read them — so remove them
 * once, on start-up.
 *
 * Nothing else is touched: COMFORTHUB_ENTRY_CONTEXT lives in sessionStorage and is
 * not a credential, and the theme preference stays.
 */
export const LEGACY_SESSION_KEY = 'COMFORTHUB_SESSION'

const LEGACY_KEY_PREFIXES = ['@@auth0spajs@@', 'auth0.']

export function clearLegacyAuthStorage(): void {
  try {
    localStorage.removeItem(LEGACY_SESSION_KEY)
    // Collect first: removing while iterating shifts the remaining indexes.
    const stale: string[] = []
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i)
      if (key && LEGACY_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        stale.push(key)
      }
    }
    for (const key of stale) localStorage.removeItem(key)
  } catch {
    // Private mode or a blocked origin: there is nothing here we can reach anyway.
  }
}
